export const TYPES = {
  ALT_BIKES: 'ALT_BIKES',
  ALT_ADMINS: 'ALT_ADMINS',
  ALT_ADMIN_LISTS: 'ALT_ADMIN_LISTS',
  ALT_ADMIN_ORDERS: 'ALT_ADMIN_ORDERS',
  ALT_COMPANY_LISTS: 'ALT_COMPANY_LISTS',
  ALT_STAFF_LISTS: 'ALT_STAFF_LISTS',
  ALT_RIDER_LISTS: 'ALT_RIDER_LISTS',
  ALT_MERCHANT_LISTS: 'ALT_MERCHANT_LISTS',
  ALT_ORDER_LISTS: 'ALT_ORDER_LISTS',
  ALT_USER_DATA: 'ALT_USER_DATA',
  ALT_zone_DATA: 'ALT_zone_DATA',
  ALT_AUTH_STATE: 'ALT_AUTH_STATE',
  ALT_ACTIVITY_LISTS: 'ALT_ACTIVITY_LISTS',
  LOGOUT: 'LOGOUT',
  USER_Orders:"USER_Orders",
  tracker:"tracker",
  Orders:"Orders",
  Dashboards:"Dashboards"

}

export default TYPES
